import React from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import SubHeaderComponent from '../../../components/header/subheader';
import '../../../assets/css/common/video/index.css';
import '../../../assets/css/common/cart/subheader.css';
import VideoDetail from './detail.js';
import VideoOther from './other.js';
import Videorecom from './recommended.js';
import TagsComponent from '../../../components/tags/tags.js';
import VideoComponent from '../../../components/video';
import {localParam,setScrollTop} from '../../../assets/js/utils/util.js';
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import { Toast } from 'antd-mobile';
import {connect} from 'react-redux';
import rAction from '../../../rAction';
import wx from 'weixin-js-sdk';

class VideoDetailIndex extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			status: '1',
			Titlestatus: '1',
			Ol_ID: props.location.search?localParam(props.location.search).search.olId:localStorage['outlineId'] !== undefined?localStorage['outlineId']:'',
			VideoSrc: '',
			AudioSrc: '',
			testPaperId: null,
			VideoLogo: '',
			merchandiseId: '',
			shareUrl: '',
			Iconshare: false,
			shareImgFlag: false,
			Org_ID: '',
			NewDate: 0,
			S058Date:{
				courseBookingType: 0
			},
			living: -1,
			name: '',
			Intro: '',
			LoginData: localStorage['LoginData'] != undefined?JSON.parse(localStorage['LoginData']):'',
			TouMFlag: false
		}
		this.AM05Id = '';
	}
	componentDidMount(props) {
		this.props.dispatch(rAction.outlineId.outlineId(this.state.Ol_ID));
    	
		setScrollTop();
		this.getJSon();
		
		// let LoginData = this.state.LoginData;
		// LoginData.role = 5;
		// this.setState({
		// 	LoginData: LoginData
		// })
	}
	getJSon(){
		let that = this;
		//播放详情
		request(config.baseUrl+'api/Study/S011?merchandiseId='+this.state.Ol_ID, "post").then(res=>{
		    //console.log(res, rAction)
		    if(res.code == 0){
				//苹果手机日期格式要转换成 2017/08/28 04:56:38
				
				let LiveTime = new Date(res.data.outline.Ol_LiveTime.replace(/-/g, "/"));
				let NowDare = new Date();
				//alert(LiveTime)
				
				this.props.dispatch(rAction.outlineXQ.XQ(res.data.outline));
				localStorage['merchand'] = JSON.stringify(res.data.outline);
				//分享
				const ua = window.navigator.userAgent.toLowerCase()
				// 判断微信
				if (ua.indexOf('micromessenger') >= 0){
					that.JianQuan();
				}
				this.setState({
					merchandiseId: res.data.outline.merchandiseId,
					Org_ID: res.data.outline.Org_ID,
					merchand: res.data.outline,
					living: res.data.living,
					name: res.data.outline.Ol_Name,
					Intro: res.data.outline.Ol_Intro,
					VideoLogo:  res.data.outline.Ol_Logo
				})
				//alert(res.data.living)
				//alert(this.state.LoginData.role)
				if(res.data.living == 0 && this.state.LoginData.role !== 5){
					//录播地址
					return 
				}else if(res.data.living == 1){
		    		//正在直播地址
			        that.InVideo(res.data.outline.Ol_LiveID);
					let NewDate = NowDare - LiveTime;
					
					this.setState({
						NewDate: NewDate
					})
		    	}else if(res.data.living == 3){
		    		//录播转直播地址
					let NewDate = NowDare - LiveTime;
					//console.log(NewDate)
					this.setState({
						NewDate: NewDate
					})
		    	}else if(res.data.living == 2){
		    		//直播还未开始
					let NewDate = LiveTime - NowDare;
					NewDate = parseInt(NewDate/1000)
					this.setTime(NewDate);
					
					//alert(NewDate)
			        this.setState({
						LiveTime:res.data.outline.Ol_LiveTime
			        })
		    	}
				this.setState({
					VideoSrc: res.data.outline.Ol_Video
				})
		    }
		});
		//预约 收藏 评论 状态信息
		request(config.baseUrl+'api/Study/S058?merchandiseId='+this.state.Ol_ID, "post").then(res=>{
		    if(res.code == 0){
		    	this.setState({
					S058Date: res.data
				})
		    }
		});
		//获取课程下的考试
		request(config.baseUrl+'api/Study/TP01?merchandiseId='+this.state.Ol_ID, "post").then(res=>{
			if(res.code == 0 && res.data.length>0){
		    	this.setState({
		    		testPaperId: '/videoList/test?testPaperId='+res.data[0].Tp_Id
		    	})
		    }
		});
		//记录浏览历史
		request(config.baseUrl+'api/Study/S012?merchandiseId='+this.state.Ol_ID, "post").then(res=>{
			
		});
	}
	//倒计时定时器
	setTime(time){
		let that = this;
		let Timer = setInterval(function(){
			time --;
			if(time <=0 ){
				clearInterval(Timer);
				that.getJSon();
			}
			//console.log(time)
			let DD = '00';
			let HH = '00';
			let MM = '00';
			let SS = '00';
			
			if(time > 60*60*24){
				let TT = parseInt(time/(60*60*24));
				DD = TT>9?TT:'0'+TT;
			}
			if(time > 60*60){
				let TT = parseInt(time%(60*60*24)/(60*60));
				HH = TT>9?TT:'0'+TT;
			}
			if(time > 60){
				let TT = parseInt(time%(60*60*24)%(60*60)/60);
				MM = TT>9?TT:'0'+TT;
			}
			if(time > 1){
				let TT = parseInt(time%(60*60*24)%(60*60)%60);
				SS = TT>9?TT:'0'+TT;
			}
			
			that.setState({
				DD: DD,
				HH: HH,
				MM: MM,
				SS: SS
			})
		}, 1000)
	}
	//正在直播地址
	InVideo(Ol_LiveID){
		request(config.baseUrl+'api/Study/L01?streamKey='+Ol_LiveID, "post").then(res=>{
			if(res.code == 0){
	    		//正在直播地址
	        	this.setState({
	        		VideoSrc: res.data.HLS,
					ZhiBo: true
	        	})
            }
        });
	}
	componentWillReceiveProps(newProps){
    	let name = newProps.location.pathname;
    	if(name === '/video/detail'){
    		this.setState({
	        	status: '1'
	        })
    	}else if(name === '/video/other'){
    		this.setState({
	        	status: '2'
	        })
    	}else if(name === '/video/recommended'){
    		this.setState({
	        	status: '3'
	        })
    	}else if(name === '/videoList/test'){
			//this.pushTestPage('/videoList/test?testPaperId='+this.state.testPaperId);
    		this.setState({
	        	status: '4'
	        })
    	}
    }
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	pushPage(url){
		if(url == '/videoList/daotu' || url == '/videoList/recommended'){
			this.props.history.push('/notfind');
		}else{
			this.props.history.push(url);
		}
	}
	pushTestPage(url){
		//
		if(this.state.testPaperId){
			this.props.history.push(url);
		}else{
			Toast.info("该课程下暂无测试题！", 2);
		}
	}
	goBack(){
        //this.props.history.goBack();
		let pathname = this.props.location.pathname;
		if(localStorage['search'] == 1){
			this.props.history.goBack();
			//this.props.history.replace(config.path+'searcgDetail?keywords='+localStorage['searchKeywords']);
		}else if (pathname === '/addressIndex/index'){
		    this.props.history.replace(config.path+'balance/index');
		}else if ((pathname === '/video/detail' || pathname === '/video/other' || pathname === '/video/recommended') && localStorage['bottomIndex'] == 1){
		    this.props.history.replace('/home/index');
		}else if ((pathname === '/video/detail' || pathname === '/video/other' || pathname === '/video/recommended') && localStorage['bottomIndex'] == 2){
		    this.props.history.replace('/home/cart');
		}else if ((pathname === '/video/detail' || pathname === '/video/other' || pathname === '/video/recommended') && localStorage['bottomIndex'] == 3){
		    this.props.history.replace('/home/college');
		}else{
		    this.props.history.goBack();
		}
    }
	Titlestatus(nub){
		this.setState({
        	Titlestatus: nub
        })
	}
	shareClick(){
		//分享
		if(this.state.shareUrl !== ''){
			this.setState({
				shareImgFlag: true
			})
			return
		}
		//Org_ID		api/AM/AM04		
		
		// request(config.baseUrl+'api/AM/AM04?orgId='+{this.state.Org_ID}+'&code='+{unionId}, "post").then(res=>{
		// 	if(res.code == 0){
		//     	this.setState({
		//     		shareUrl: res.data,
		// 			shareImgFlag: true
		//     	})
		//     }
		// });
		let LoginData = JSON.parse(localStorage['LoginData']); 
		request(config.baseUrl+'api/Study/S046?merchandiseId='+this.state.Ol_ID+'&nickname='+LoginData.accName+'&unionId='+LoginData.unionId, "post").then(res=>{
			if(res.code == 0){
		    	this.setState({
		    		shareUrl: res.data,
					shareImgFlag: true
		    	})
		    }
		});
	}
	Iconshare(){
		this.setState({
			Iconshare: true
		})
	}
	CloseClick(){
		this.setState({
			Iconshare: false,
			shareImgFlag: false
		})
	}
	YuYueClick(){
		//console.log(1)
		let data= {
			"merchandiseId": this.state.merchandiseId,
			"cb_CBTime": this.state.LiveTime
		}
		let S058Date = this.state.S058Date;
		if(S058Date.courseBookingType == 0){
			//预约课程
			request(config.baseUrl+'api/Study/S050', "post", data).then(res=>{
				if(res.code == 0){
					Toast.info(res.message, 2);
					S058Date.courseBookingType = 1;
					this.setState({
						S058Date: S058Date
					})
			    }
			});
		}else{
			//取消预约
			request(config.baseUrl+'api/Study/S051', "post", data).then(res=>{
				if(res.code == 0){
					Toast.info(res.message, 2);
					S058Date.courseBookingType = 0;
					this.setState({
						S058Date: S058Date
					})
			    }
			});
		}
	}
	
	JianQuan() {
		//鉴定权限是否可用
		let data = {
			url: window.location.href
		}
		let that = this;
		request(config.baseUrl+'api/AM/AM03', "post", data).then(res=>{
			if(res.code == 0){
		    	that.zhiXing(res.data);
		    }
		});
	}
	zhiXing(json) {
		let data = json;
		let that = this;
		data.jsApiList = [
			"updateAppMessageShareData",
			"updateTimelineShareData",
			'onMenuShareAppMessage',
			'onMenuShareTimeline',
		];
		data.openTagList = [
			"wx-open-launch-app"
		];
		data.debug = false;
		wx.config(data);
		wx.ready(function (res) {
			console.log(res)
		  // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
			that.fenxiang();
			that.OpApp();
		});
		
	}
	fenxiang() {
		// 设置成功
		var share = {
			title: this.state.name, // 分享标题
			desc: this.state.Intro, // 分享描述
			link: 'http://ptt.zlgxt.cn/h5/#/video/other?olId='+this.state.Ol_ID , // 分享链接
			imgUrl: this.state.VideoLogo, // 分享图标
			success: function() {}
		}
		//分享给朋友
		wx.updateAppMessageShareData(share);
		wx.onMenuShareAppMessage(share);
		//分享给朋友圈
		wx.updateTimelineShareData(share);
		wx.onMenuShareTimeline(share);
	}
	OpApp() {
		this.openApp = document.querySelector('.openAppCent');
		this.openApp.innerHTML = `<wx-open-launch-app id="launch-btn" appid="wx42bb27797e4040b2" extinfo="123456" >
			<template>
				<style>
					.btn { 
						width: 100%;
						padding: 10px 0;
						border-radius: 6px;
						border: none;
						background-color: #00CCA9;
						color: #fff;
						font-size: 100%;
						z-index: 1002;
					}
				</style>
				<button class="btn">更多内容请<br />进入App内查看</button>
			</template>
		</wx-open-launch-app>`;
		var launchBtn = document.getElementById('launch-btn');
		console.log(launchBtn)
		launchBtn.addEventListener('launch', function (e) {
			//alert('success');
		});
		launchBtn.addEventListener('error', function (e) {
			alert('未检测到App，跳转默认浏览器下载App？');
			window.location.href = "http://ptt.zlgxt.cn/h5/downloadAPP/";
		});
	}
	TouMClick(){
		let TouMFlag = this.state.TouMFlag;
		this.setState({
			TouMFlag: !TouMFlag
		})
	}
	render() {
		return(
			<div>
				<div className={'sub-header'}>
	                <div className={'back'} onClick={this.goBack.bind(this)}></div>
	                <div className={'videoTitle'}>
			    		<div className={this.state.Titlestatus === '1'?'active':''} onClick={this.Titlestatus.bind(this, '1')}>
			        		视频
			        		<span></span>
			        	</div>
						{
							// <div className={this.state.Titlestatus === '2'?'active':''} onClick={this.Titlestatus.bind(this, '2')}>
							// 	音频
							// 	<span></span>
							// </div>
						}
			    		
			        </div>
					
	            </div>
		        <div className={'video-page'}>
					<div className={'share'} onClick={this.shareClick.bind(this)}></div>
		        	{
		        		this.state.VideoSrc !== '' && this.state.living !== -1?
						<VideoComponent src={this.state.VideoSrc} logo={this.state.VideoLogo} NewDate={this.state.NewDate} live={this.state.living} />
		        		:this.state.living == 2?<div className={'video'}>
					        <div className={"null videoNull"}>
								<img src={this.state.VideoLogo} className='videoNull-img' />
								<div className={"videoNull-div"}>
									<span>直播尚未开始!</span>
								</div>
							</div>
			        	</div>:<div className={'video'}>
						    <div className={"null videoNull"}>
								<img src={this.state.VideoLogo} className='videoNull-img' />
								{
									// <img src={require('../../../assets/images/common/load.gif')} className='videoNull-img videoNull-img2' />
								}
							</div>
						</div>
		        	}
					<div className={this.state.living != 2?'quick-nav video-nav':'quick-nav hide'} style={{padding: '0',height: '1.05rem'}}>
						<img src={require('../../../assets/images/guG.png')} />
					</div>
	                <div className={'video-content'}>
			        	<Link to='/video/other'>
				    		<div className={this.state.status === '2'?'active':''}>
				        		互动
				        		<span></span>
				        	</div>
			        	</Link>
						<Link to='/video/detail'>
							<div className={this.state.status === '1'?'active':''}>
								详情
								<span></span>
							</div>
						</Link>
						<Link to={{
								pathname:'/video/recommended',
								state:{merchand:this.state.merchand}
							}}>
							<div className={this.state.status === '3'?'active':''}>
								推荐
								<span></span>
							</div>
						</Link>
						<Link to={
							{
							  pathname:'/videoList/test',
							  state:{testPaperId:this.state.testPaperId}
							}
						}>
							<div className={this.state.status === '4'?'active':''}>
								考试
								<span></span>
							</div>
						</Link>
						<Link to={{
							pathname:'/comment',
							state:{merchand:this.state.merchand}
						}}>
							<div>
								评论
								<span></span>
							</div>
						</Link>
			        </div>
					<div className={this.state.living == 2?'quick-nav video-nav':'quick-nav hide'}>
						<p>
							<span>{this.state.DD}</span>天&nbsp;&nbsp;
							<span>{this.state.HH}</span>时&nbsp;&nbsp;
							<span>{this.state.MM}</span>分&nbsp;&nbsp;
							<span>{this.state.SS}</span>秒 
						</p>
						<div className={'video-nav-btn'}>
							<button onClick={this.shareClick.bind(this)}>邀好友赢积分</button>
							<button onClick={this.YuYueClick.bind(this)}>{this.state.S058Date.courseBookingType == 0?'立即预约':'取消预约'}</button>
						</div>
					</div>
	                <div>
		                <Switch>
		                	<Route path='/video/detail' component={VideoDetail}></Route>
		                	<Route path='/video/other' component={VideoOther}></Route>
							<Route path='/video/recommended' component={Videorecom}></Route>
		                </Switch>
	                </div>
		        </div>
				<div className={this.state.shareImgFlag?'shareAlert':'hide'}>
					<div className={'shareImg'}>
						<img src={this.state.shareUrl} />
					</div>
					<div className={'shareFoot'}>
						<p>
							<span className={"shareFootSp"}>分享得积分，</span>
							邀请好友一起学习
							<span className={"shareFootClose"} onClick={this.CloseClick.bind(this)}>
								<img src={require('../../../assets/images/common/search_x.png')} />
							</span>
						</p>
						<div className={'shareFootDiv'}>
						{
							// <div>
							// 	<div>
							// 		<img src={require('../../../assets/images/video/share3.png')} />
							// 	</div>
							// 	<span>保存到手机</span>
							// </div>
						}
							
							<div onClick={this.Iconshare.bind(this)}>
								<div>
									<img src={require('../../../assets/images/video/share1.png')} />
								</div>
								<span>微信好友</span>
							</div>
							<div onClick={this.Iconshare.bind(this)}>
								<div>
									<img src={require('../../../assets/images/video/share2.png')} />
								</div>
								<span>微信朋友圈</span>
							</div>
						</div>
					</div>
					<div className={this.state.Iconshare?'shareFootArrow':'hide'}>
						<p>点击分享好友，共同进步吧!</p>
						<div>
							<img src={require('../../../assets/images/video/arrow.png')} />
						</div>
					</div>
				</div>
				<div className={this.state.LoginData.role == 5?'hide':'TouM'} onClick={this.TouMClick.bind(this)}></div>
				<div className={this.state.TouMFlag?'openApp':'openApp hide'}>
					{
						// <span className={"openAppClose"} onClick={this.TouMClick.bind(this)}>
						// 	<img src={require('../../../assets/images/common/x.png')} />
						// </span>
					}
					
					<div className={'openAppCent'}></div>
				</div>
		    </div>
		);
	}
}
export default connect((state)=>{
	return {
		state: state
	}
})(VideoDetailIndex)
